import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked, Renderer2, DoCheck } from '@angular/core';
@Component({
  selector: 'ags-formation-doc',
  templateUrl: './formation-doc.component.html',
  styleUrls: ['./formation-doc.component.scss']
})
export class FormationDocComponent implements OnInit, AfterViewChecked {
  @ViewChild('menuDocument') menuDocument: ElementRef<HTMLElement>;

  public data: any[] = [
    {
      text: 'MON CLIENT',
      items: [{ text: 'Rapport de fin de formation.pdf' }, { text: 'Convention de formation' }]
    }
  ];
  constructor(private renderer: Renderer2) {}

  ngOnInit() {}

  ngAfterViewChecked(): void {
    const listKendo: NodeListOf<Element> = this.menuDocument.nativeElement.querySelectorAll('li.k-treeview-item');
    if (listKendo.length) {
      let canCallAddDownloadIcon: boolean;
      const listToModify = [];
      listKendo.forEach(el => {
        const subList = el.querySelectorAll('li.k-treeview-item');
        if (subList.length) {
          canCallAddDownloadIcon = true;
          listToModify.push(subList);
        }
      });
      if (canCallAddDownloadIcon) {
        this.addDownloadIcon(listToModify);
      }
    }
  }

  addDownloadIcon(listToModify = []) {
    for (const subList of listToModify) {
      for (const item of subList) {
        const lineItem = item.querySelector('div.k-mid > span.k-in');
        if (!lineItem.classList.contains('icon-dl-ok')) {
          const span = this.renderer.createElement('span');
          this.renderer.addClass(span, 'k-icon');
          this.renderer.addClass(span, 'k-i-download');
          this.renderer.setStyle(span, 'margin-left', 'auto');
          this.renderer.addClass(lineItem, 'icon-dl-ok');
          this.renderer.setStyle(lineItem, 'width', '100%');
          this.renderer.setStyle(lineItem, 'padding-left', '24px');
          this.renderer.appendChild(lineItem, span);
        }
      }
    }
  }
}
